import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";

const controls = [
  {
    title: "reg_number_car",
    reg: /^.{12,63}$/,
  },
  {
    title: "reg_special",
    reg: /[@#$%^&+=*?!-]/,
  },
  {
    title: "reg_number",
    reg: /[0-9]/,
  },
  {
    title: "reg_lower",
    reg: /[a-z]/,
  },
  {
    title: "reg_capital",
    reg: /[A-Z]/,
  },
];

const ControlPassword = ({ value }) => {
  const { t } = useTranslation();
  return (
    <ul>
      {controls.map((el) => (
        <li className="control-password">
          {t(el.title)}
          {el.reg.test(value) && value ? (
            <CheckIcon sx={{ color: "green" }} />
          ) : (
            <ClearIcon sx={{ color: "red" }} />
          )}
        </li>
      ))}
    </ul>
  );
};

export default ControlPassword;
